import { useEffect, type ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthUIProvider } from '@daveyplate/better-auth-ui';
import { Toaster, toast } from 'sonner';
import App from './app/app';
import '../src/css/app.scss';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { initializeSentry } from 'services/sentry';
import { authClient } from './lib/auth-client';
import { authUIConfig } from './lib/auth-ui-config';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container element #root not found');
}
const root = createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});
initializeSentry();

const Index = () => {
  const isSmallViewport = false;

  useEffect(() => {
    if (!isSmallViewport) {
      toast.dismiss('compact-ui-warning');
      return;
    }

    toast.warning('This application is not optimized for mobile use.', {
      id: 'compact-ui-warning',
      duration: 8000,
    });
  }, [isSmallViewport]);

  return (
    <BrowserRouter>
      <AuthUIProvider
        authClient={authClient as unknown as ComponentProps<typeof AuthUIProvider>['authClient']}
        {...authUIConfig}
      >
        <App />
        <Toaster richColors position="bottom-right" />
      </AuthUIProvider>
    </BrowserRouter>
  );
};

root.render(<Index />);

const welcome = (_id?: string) => console.log('Welcome to UrbanMetrix!!!');
welcome('de529c70-eb80-4dfb-9540-5075db7545bf');
